import { useId } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '..';
import { FormControl } from '../..';
import { SelectInputProps } from './types';
import { useTranslation } from 'react-i18next';
import { hasUnknownOption } from '@forms/helpers';
import { cn } from '@utils/cn';

export const SelectInput = ({
  name,
  value,
  onChange,
  options,
  children,
  error,
  defaultValue,
  placeholder,
  disabled,
  open,
  setOpen,
  popoverRef,
  className,
  contentClassName,
  matchTriggerWidth,
}: SelectInputProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms.default.select' });
  const id = useId();
  const hasInvalidOption = hasUnknownOption(options, value);

  const trigger = (
    <SelectTrigger name={name} disabled={disabled} className={className}>
      <SelectValue
        placeholder={
          hasInvalidOption || error ? defaultValue?.name || value : placeholder || t('placeholder')
        }
        id={name}
      />
    </SelectTrigger>
  );

  return (
    <Select
      open={open}
      onOpenChange={setOpen}
      name={name}
      value={hasInvalidOption && !error ? '' : value}
      onValueChange={onChange}
      disabled={disabled}>
      {name ? (
        <FormControl aria-invalid={hasInvalidOption || Boolean(error)}>{trigger}</FormControl>
      ) : (
        trigger
      )}
      {children || (
        <SelectContent
          container={popoverRef?.current}
          className={cn(
            matchTriggerWidth &&
              'w-[var(--radix-select-trigger-width)] max-w-[var(--radix-select-trigger-width)] overflow-x-hidden',
            contentClassName,
          )}>
          {options.map((el) =>
            matchTriggerWidth ? (
              <SelectItem
                key={`select-${id}-${el.value}`}
                value={el.value}
                disabled={el.disabled}
                itemTextAsChild>
                <span className="min-w-0 truncate" title={el.name}>
                  {el.name}
                </span>
              </SelectItem>
            ) : (
              <SelectItem key={`select-${id}-${el.value}`} value={el.value} disabled={el.disabled}>
                {el.name}
              </SelectItem>
            ),
          )}
        </SelectContent>
      )}
    </Select>
  );
};
